/**
 * Route constants for the restaurant application
 */
export const ROUTE_PATHS = {
  HOME: '/',
} as const;

/**
 * Base interface for food items
 */
export interface MenuItem {
  id: string;
  name: string;
  price: number;
  description?: string;
}

/**
 * Interface for Menu Sets (Single, Couple, Talam)
 */
export interface MenuSet extends MenuItem {
  type: 'ayam' | 'kambing';
  pax: string;
  imageKey: string;
}

/**
 * Interface for Add-on items
 */
export interface AddOn extends MenuItem {}

/**
 * Menu sets data representing the core offering of NASI ARAB MERWIY
 */
export const MENU_SETS: MenuSet[] = [
  {
    id: 'single-ayam',
    name: 'Single Set Ayam',
    type: 'ayam',
    pax: '1 Person',
    price: 17,
    description: 'Fragrant Mandy rice served with quarter chicken, authentic Sahawiq, and fresh Salatah.',
    imageKey: 'MANDY_DISH_1'
  },
  {
    id: 'single-kambing',
    name: 'Single Set Kambing',
    type: 'kambing',
    pax: '1 Person',
    price: 25,
    description: 'Tender mutton pieces served over aromatic Mandy rice with Sahawiq and Salatah.',
    imageKey: 'MANDY_DISH_9'
  },
  {
    id: 'couple-ayam',
    name: 'Couple Set Ayam',
    type: 'ayam',
    pax: '2 Persons',
    price: 33,
    description: 'Perfect for two. Half chicken served with double portions of rice and side condiments.',
    imageKey: 'MANDY_DISH_1'
  },
  {
    id: 'couple-kambing',
    name: 'Couple Set Kambing',
    type: 'kambing',
    pax: '2 Persons',
    price: 49,
    description: 'Generous portions of mutton for two, served with Mandy rice and traditional sides.',
    imageKey: 'MANDY_DISH_9'
  },
  {
    id: 'talam-ayam',
    name: 'Talam Set Ayam',
    type: 'ayam',
    pax: '4-5 Persons',
    price: 59,
    description: 'Family-sized talam platter with whole chicken and premium Mandy rice. Includes large sides.',
    imageKey: 'MANDY_FAMILY_PLATTER_4'
  },
  {
    id: 'talam-kambing',
    name: 'Talam Set Kambing',
    type: 'kambing',
    pax: '4-5 Persons',
    price: 95,
    description: 'The ultimate family feast. Premium mutton platter served with large portions of rice.',
    imageKey: 'MANDY_FAMILY_PLATTER_4'
  }
];

/**
 * Add-on items for customization
 */
export const ADD_ONS: AddOn[] = [
  {
    id: 'extra-rice',
    name: 'Rice (One Bowl)',
    price: 3,
    description: 'Extra portion of our signature Mandy rice.'
  },
  {
    id: 'extra-salatah',
    name: 'Salatah / Acar',
    price: 3,
    description: 'Traditional Arabic fresh vegetable salad.'
  },
  {
    id: 'extra-sahawiq',
    name: 'Sahawiq / Sambal',
    price: 3,
    description: 'Spicy and tangy traditional chili sauce.'
  }
];

/**
 * Delivery coverage areas
 */
export const DELIVERY_AREAS = [
  'Meru',
  'Klang',
  'Shah Alam',
  'Setia Alam',
  'Puncak Alam',
  'Klang Valley Areas'
];

/**
 * Business contact information and operational details
 */
export const CONTACT_INFO = {
  name: 'NASI ARAB MERWIY',
  baseLocation: 'Meru, Klang',
  phone: '+601136720984',
  whatsappUrl: 'https://wa.me/601136720984',
  deliveryServices: ['Grab Express', 'Lalamove', 'Personal Rider'],
  year: 2026
};